import BrandView from "./BrandView";

export default BrandView;
